/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : ACCOUNT ENTER INFORMATION : STYLES --------------- ++++++++++ */
export default theme =>({
    enterinformation: {
        '& .message':{
            marginBottom: pxToEm(37)
        },
        '& .divider': {
            marginTop: pxToEm(30)
        },
        '& .name-payment-type': {
            width: '100%',
            maxWidth: pxToEm(361)
        },
        '& .griditem': {
            '&.type-full':{
                width: '100%',
                maxWidth: pxToEm(961),
                '& .field': {
                    width: '100%',
                    maxWidth: pxToEm(990)
                }
            }
        },
        '& .payment-method': {
            opacity: '0',
            animationName: 'fadeInUp',
            animationDuration: '.2s',
            animationFillMode: 'forwards',
            animationDelay: '.15s',
            display: 'flex',
            flexDirection:'column',
            '& .variant-neutral':{
                marginBottom: '0'
            },
            '& .notification': {
                width: '100%',
                marginLeft: '0',
                marginRight: '0'
            }
        },
        '& .name-upload-form':{
            height: pxToEm(95),
            marginTop: pxToEm(20),
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            '& .name-exclamation-circle':{
              fontSize: pxToEm(14)
            },
            '&.valid-false':{
                color: theme.color.attention.medium.contrast,
                '& .input-button':{
                    border: `${theme.color.attention.medium.contrast} ${pxToEm(2)} solid`,
                    background: theme.color.attention.medium.swatch,
                    '& .button-text':{
                        color: theme.color.attention.medium.contrast
                    }
                }
            }
        }
    }
});
